import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import backArrowIcon from '../../assets/img/back-arrow.png';
import exportIcon from '../../assets/icon/icon-export-excel.svg';
import { API_URL } from '../../utils/constant';
import { formatReceiptCurrency } from '../../utils/format-number';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Pagination } from '../../components/Pagination';

const LIMIT = 20;

const YearlySaleReport = () => {
    const backPath = '/report/list';
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => currentYear - index);
    const [reportYear, setReportYear] = useState(currentYear);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const visibleData = data.slice((page - 1) * LIMIT, page * LIMIT);

    const fetchYearlySaleReport = () => {
        let url = API_URL + `/report/yearly_sale?year=${reportYear}`;
        return axios
            .get(`${url}`, {
                withCredentials: true,
            })
            .then((response) => {
                setData(response.data.data);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    useEffect(() => {
        setPage(1);
    }, [data]);

    const calculateTotal = (items, key) => {
        let total = 0;
        for (const item of items) {
            total += Number(item[key] || 0);
        }
        return total;
    };

    const handleExportClick = (fileName) => {
        const table = document.querySelector('#xlsx-export-all').cloneNode(true);
        const workbook = XLSX.utils.table_to_book(table, { display: false });
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <div className='sub-page-layout-1'>
            <div className='container' style={{ height: 'auto' }}>
                <div className='report-page-header text-3xl'>
                    <div className='report-page-heading'>
                        <Link className='back-to-page' to={backPath}>
                            <img src={backArrowIcon} />
                            Back
                        </Link>
                        <h1 className='sub-page-title'>Yearly Sale Report</h1>
                    </div>
                    <div className='report-toolbar'>
                        <div className='report-select-narrow'>
                            <div className='dd-container'>
                                <select
                                    required
                                    name='report_year'
                                    value={reportYear}
                                    onChange={(e) => setReportYear(Number(e.target.value))}
                                    className='x-input dropdown'
                                    size={1}
                                >
                                    {yearOptions.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <button className='gold-btn report-run-button' onClick={fetchYearlySaleReport}>
                            Run Report
                        </button>
                        <button
                            className='gold-btn report-export-button'
                            onClick={() => {
                                handleExportClick(`Yearly_Sale_Report_for_${reportYear}.xlsx`);
                            }}
                        >
                            <img src={exportIcon} alt='export excel icon' />
                            <span>Export Excel</span>
                        </button>
                    </div>
                </div>
                <div className='table-container'>
                    <table className='x-table' id='xlsx-export'>
                        <thead>
                            <tr style={{ position: 'absolute', width: '0', height: '0', padding: '0', border: '0' }}>
                                <th className='hidden' colSpan={3}></th>
                                <th className='hidden'>Year</th>
                                <th className='hidden'>{reportYear}</th>
                            </tr>
                            <tr style={{ position: 'absolute', width: '0', height: '0', padding: '0', border: '0' }}>
                                <th className='hidden' colSpan={2}></th>
                            </tr>
                            <tr>
                                <th>Month</th>
                                <th className='report-amount'>Retail Sales MMK</th>
                                <th className='report-amount'>Retail Sales THB</th>
                                <th className='report-amount'>Wholesale MMK</th>
                                <th className='report-amount'>Wholesale THB</th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleData?.map((item, i) => (
                                <tr key={i}>
                                    <td>{item['month_name']}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['retail_sale_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['retail_sale_thb'], 'THB')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['wholesale_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['wholesale_thb'], 'THB')}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td style={{ fontWeight: 'bold' }}>Total Amount</td>
                                <td className='report-amount' style={{ fontWeight: 'bold' }}>{formatReceiptCurrency(calculateTotal(data, 'retail_sale_mmk'), 'MMK')}</td>
                                <td className='report-amount' style={{ fontWeight: 'bold' }}>{formatReceiptCurrency(calculateTotal(data, 'retail_sale_thb'), 'THB')}</td>
                                <td className='report-amount' style={{ fontWeight: 'bold' }}>{formatReceiptCurrency(calculateTotal(data, 'wholesale_mmk'), 'MMK')}</td>
                                <td className='report-amount' style={{ fontWeight: 'bold' }}>{formatReceiptCurrency(calculateTotal(data, 'wholesale_thb'), 'THB')}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div style={{ display: 'none' }}>
                    <table id='xlsx-export-all'>
                        <thead>
                            <tr>
                                <th>Month</th>
                                <th className='report-amount'>Retail Sales MMK</th>
                                <th className='report-amount'>Retail Sales THB</th>
                                <th className='report-amount'>Wholesale MMK</th>
                                <th className='report-amount'>Wholesale THB</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item, i) => (
                                <tr key={`export-${i}`}>
                                    <td>{item['month_name']}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['retail_sale_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['retail_sale_thb'], 'THB')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['wholesale_mmk'], 'MMK')}</td>
                                    <td className='report-amount'>{formatReceiptCurrency(item['wholesale_thb'], 'THB')}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>Total Amount</td>
                                <td className='report-amount'>{formatReceiptCurrency(calculateTotal(data, 'retail_sale_mmk'), 'MMK')}</td>
                                <td className='report-amount'>{formatReceiptCurrency(calculateTotal(data, 'retail_sale_thb'), 'THB')}</td>
                                <td className='report-amount'>{formatReceiptCurrency(calculateTotal(data, 'wholesale_mmk'), 'MMK')}</td>
                                <td className='report-amount'>{formatReceiptCurrency(calculateTotal(data, 'wholesale_thb'), 'THB')}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div className='w-full flex justify-end mt-4'>
                    <Pagination page={page} totalCount={data.length} limit={LIMIT} onChange={setPage} />
                </div>
            </div>
        </div>
    );
};

export default YearlySaleReport;
